import { UploadFile } from "antd/es/upload";
import { UserInfoResponseModel } from "api/repositories/accounts/model/UserInfoResponse";
import { PathConfigDetailResponseModel } from "api/repositories/pathConfig/model/detail/PathConfigDetailResponseModel";
import { SidebarMenuConfigModel } from "api/repositories/sidebarMenu/model/SidebarMenuConfigModel";
import { VideoGenerationResponseModel } from "api/repositories/videoGeneration/model/VideoGenerationResponseModel";
import { Dispatch, SetStateAction } from "react";
import { strings } from "utils/localizedStrings";

export class ContextModel {
  user: UserInfoResponseModel;
  getPartnerInfo: (value: any) => void;
  info: string;
  menuConfig: SidebarMenuConfigModel;
  getRoles: () => Promise<void>;
  getSidebar: (role: boolean, language: string) => Promise<void>;
  isAuthenticated: () => boolean;
  language?: string;
  setLanguage?: Dispatch<SetStateAction<string>>;
  localStrings!: typeof strings;
  parameters: PathConfigDetailResponseModel["config"];
  setParameters: Dispatch<
    SetStateAction<PathConfigDetailResponseModel["config"]>
  >;
  setLocalStrings!: Dispatch<SetStateAction<typeof strings>>;
  sessionLog: {
    sessionId: Array<string>;
    portrait: UploadFile;
    image: string;
    genResult?: VideoGenerationResponseModel;
  };
  setSessionLog: Dispatch<
    SetStateAction<{
      sessionId: Array<string>;
      portrait: UploadFile;
      image: string;
      genResult?: VideoGenerationResponseModel;
    }>
  >;
  config: Object;
  getConfig: () => Promise<void>;
}
